// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class Field {
    static getAttributeTypeMap() {
        return Field.attributeTypeMap;
    }
}
Field.discriminator = undefined;
Field.additionalProperties = false;
Field.attributeTypeMap = [
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "value",
        "baseName": "value",
        "type": "string"
    },
];
//# sourceMappingURL=field.js.map